/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_GenderInputs */

const en_ui_thresholds_gender = /** @type {(inputs: Ui_Thresholds_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

const de_ui_thresholds_gender = /** @type {(inputs: Ui_Thresholds_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht`)
};

/**
* | output |
* | --- |
* | "Gender" |
*
* @param {Ui_Thresholds_GenderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_gender = /** @type {((inputs?: Ui_Thresholds_GenderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_GenderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_gender(inputs)
	return de_ui_thresholds_gender(inputs)
});